import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchAll(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `orders`,
          qs: eventBucket
            ? {
                conditions: JSON.stringify({
                  event_bucket: eventBucket
                })
              }
            : undefined,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.orders);
        }
      );
    });
  },

  fetchAllForPerson(apiKey, person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/${person}/orders`,
          qs: { limit: "all" },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.orders);
        }
      );
    });
  },

  fetchMore(apiKey, eventBucket, startingId, limit, { godOrders }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `orders`,
          qs: {
            conditions: JSON.stringify(
              Object.assign(
                {},
                eventBucket && { event_bucket: eventBucket },
                startingId && { _id: { $lt: startingId } }
              )
            ),
            limit: limit,
            god_orders: godOrders ? true : undefined
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchOne(apiKey, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `orders/${id}`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  resendConfirmation(apiKey, options) {
    options = Object.assign({}, options);
    let { id } = options;
    delete options.id;

    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders/${id}/resend`,
          json: options,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  generateRefundOptions(apiKey, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders/${id}/refund_options`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  refund(apiKey, id, amount) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders/${id}/refund`,
          api_key: apiKey,
          json:
            typeof amount === "object"
              ? amount
              : {
                  amount: amount
                }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(apiKey, order, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `orders/${order}`,
          json: values,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  downloadReceipt(orderId) {
    window.open(`${config.endpoint}orders/${orderId}/receipt.pdf`);
  },

  downloadDonationReceipt(orderId) {
    window.open(`${config.endpoint}orders/${orderId}/donation-receipt.pdf`);
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/OrderUtil.js